type ApiCallError = Error & { status?: number; endpoint?: string };

export function isStateChangingHttpMethod(method: string | undefined): boolean {
  return ["POST", "PUT", "DELETE", "PATCH"].includes(method || "GET");
}

/**
 * Parse Http Error Message.
 */
export async function parseHttpErrorMessage(
  response: Response,
  fallbackMessage: string
): Promise<string> {
  const contentType = response.headers.get("content-type") || "";

  try {
    if (contentType.includes("application/json")) {
      const errorData = (await response.json()) as { error?: string; message?: string };
      return errorData.error || errorData.message || fallbackMessage;
    }

    const text = await response.text();
    if (text) {
      return `${fallbackMessage} - ${text.slice(0, 200)}`;
    }
  } catch {
    // ignore parse errors; fall back to status-based message
  }

  return fallbackMessage;
}

export function createApiCallError(
  message: string,
  status: number,
  endpoint: string
): ApiCallError {
  const err: ApiCallError = new Error(message);
  err.status = status;
  err.endpoint = endpoint;
  return err;
}

export function rethrowAbortError(error: unknown, timeoutMs: number): never {
  if (isAbortError(error)) {
    throw new Error(`Request timeout after ${timeoutMs}ms`);
  }
  throw error;
}

function isAbortError(error: unknown): boolean {
  return Boolean(
    error &&
    typeof error === "object" &&
    "name" in error &&
    (error as { name?: string }).name === "AbortError"
  );
}

export const ADMIN_API_TIMEOUT_MS = 30000;
